import React , {useEffect} from "react"

import { connect } from "react-redux";



//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import SociosList from "pages/SociosList/SociosList";
import Widgets from "pages/Widgets/Widgets";
import ChartActividades from "pages/Charts/ChartActividades";
import GraficasDash from "pages/GraficasDash/GraficasDash";
const Dashboard = (props) => {

  document.title = "Dashboard | GesSindical - Responsive Bootstrap 5 Admin Dashboard";


  const breadcrumbItems = [
    { title: "GesSindical", link: "#" },
    { title: "Dashboard", link: "#" }
  ]

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard' , breadcrumbItems)
  },)

 

  return (
    <React.Fragment>

    <Widgets/>  
    <SociosList/>

   <GraficasDash/>


     

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);